var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.7,2.3c-3.1-3.1-8.2-3.1-11.3,0C0.8,3.9,0,5.9,0,8s0.8,4.1,2.3,5.7C3.9,15.2,6,16,8,16s4.1-0.8,5.7-2.3 C16.8,10.5,16.8,5.5,13.7,2.3z M13,13c-2.7,2.7-7.2,2.7-9.9,0C1.7,11.6,1,9.9,1,8S1.7,4.4,3,3C4.4,1.7,6.2,1,8,1s3.6,0.7,5,2.1 C15.7,5.8,15.7,10.2,13,13z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0 1 -1 0 18 -1)",
    d: "M9.20928 5.51172C9.13951 5.44195 9.06975 5.44195 8.99998 5.44195C8.93021 5.44195 8.86044 5.44195 8.79068 5.51172L5.86044 8.37218C5.79068 8.44195 5.72091 8.65125 5.86044 8.72102C5.93021 8.79079 6.13951 8.86056 6.20928 8.72102L8.72091 6.27916L8.72091 14.2326C8.72091 14.3722 8.86044 14.5117 8.99998 14.5117C9.13951 14.5117 9.27905 14.3722 9.27905 14.2326L9.27905 6.34893L11.7209 8.79079C11.7907 8.86056 12 8.86056 12.0697 8.79079C12.1395 8.72102 12.1395 8.51172 12.0697 8.44195L9.20928 5.51172Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight3);
export default __webpack_public_path__ + "static/media/arrow-right-3.ce6c9223265a12b76bccbc4597a42b62.svg";
export { ForwardRef as ReactComponent };